module.exports = {
    resetPassword: {
        en: "Reset new password",
        fi: "Uusi salasana"
    },
    email: {
        en: "Email",
        fi: "Sähköposti"
    },
    emailPlaceholder: {
        en: "Email",
        fi: "Sähköpostiosoite"
    },
    emailToolTip: {
        en: "Email is required",
        fi: "Sähköposti on pakollinen"
    },
    newPassword: {
        en: "New password",
        fi: "Uusi salasana"
    },
    newPasswordPlaceholder: {
        en: "New password",
        fi: "Uusi salasana"
    },
    newPasswordToolTip: {
        en: "New password is required",
        fi: "Uusi salasana on pakollinen"
    },
    confirmNewPassword: {
        en: "Confirm new password",
        fi: "Vahvista uusi salasana"
    },
    confirmNewPasswordPlaceholder: {
        en: "Confirm new password",
        fi: "Vahvista uusi salasana"
    },
    confirmNewPasswordToolTip: {
        en: "Confirm new password is required",
        fi: "Uuden salasanan vahvistus on pakollinen"
    },
    invalidEmailDetected: {
        en: "Invalid email detected",
        fi: "Ei sähköpostiosoite"
    },
    submitBtn: {
        en: "Submit",
        fi: "Lähetä"
    }
}